import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useCampaignsTable } from 'src/pages/orders/campaigns/useCampaignsTable';
import CustomButton from 'src/core/ui/CustomButton';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';

export const CampaignsTablePage = () => {
  const [columns, tableSettings] = useCampaignsTable();
  return (
    <>
      <PageHeader title={'Campaigns'} subTitle={'View and manage all campaigns'} components={[
          ...generateTablePageButtons(tableSettings),
          { component: <CustomButton title="New Campaign" icon={<AddTwoToneIcon />} actionUrl="/orders/campaigns/create" /> }
        ]}
      />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};
export default CampaignsTablePage;
